import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// import { DownloadOutlined } from '@ant-design/icons';
import { Box, Flex } from 'atoms';
// import downloadIcon from 'assets/download.svg';
import { getSignedUrl } from 'store/commonSlice';

export default function DownloadFiles({ entity, files = [] }) {
	const dispatch = useDispatch();
	const [downloadLinks, setDownloadLinks] = useState([]);

	useEffect(() => {
		if (files?.length > 0) {
			const data = {
				url_type: 'download',
				data: {
					entity,
					keys: files,
				},
			};

			dispatch(getSignedUrl(data)).then((res) => {
				setDownloadLinks(res?.data);
			});
		}
	}, [dispatch, entity, files]);

	if (files?.length === 0 || downloadLinks?.length === 0) {
		return null;
	}

	return (
		<Flex>
			{downloadLinks?.map((item) => (
				<Box key={item?.key} cursor="pointer" title={item?.filename}>
					<Link
						to={item?.url}
						target="_blank"
						download
						style={{ background: '#1890ff', padding: '10px', color: '#fff' }}
					>
						Click here to Download File
					</Link>
				</Box>
			))}
		</Flex>
	);
}

DownloadFiles.propTypes = {
	entity: PropTypes.string,
	files: PropTypes.array,
};
